export default {"src":"/_next/static/media/exit_confirmation.5cb875ae.svg","height":240,"width":240,"blurWidth":0,"blurHeight":0};